import { LoadingScreenApp } from 'components/LoadingScreen';
import PreApp from 'components/PreApp/PreApp';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import { redirects } from 'redirects';
import store from 'redux-store/store';
import { StyleSheetManager } from 'styled-components';

redirects();

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
  <Router>
    <Provider store={store}>
      <StyleSheetManager enableVendorPrefixes>
        <LoadingScreenApp />
        <HelmetProvider>
          <PreApp />
        </HelmetProvider>
      </StyleSheetManager>
    </Provider>
  </Router>
);
